import type {
  FormattedAdminUser,
  MemberNotesColumns
} from '@library/types/members/memberNotes';
import type { TableColumn } from '@library/types/utils';

export const MEMBER_NOTES_HEADER: Array<TableColumn<MemberNotesColumns>> = [
  {
    column: 'admin_user',
    essential: true,
    label: 'Admin User',
    sortEnabled: false,
    width: 'w-[30%]'
  },
  {
    column: 'created_at',
    essential: true,
    label: 'Created At',
    sortEnabled: false,
    width: 'w-1/5'
  },
  {
    column: 'description',
    essential: true,
    label: 'Description',
    sortEnabled: false
  },
  {
    column: 'delete_note',
    essential: true,
    label: '',
    sortEnabled: false,
    width: 'w-11'
  }
];

export const DEFAULT_ADMIN_USER: FormattedAdminUser = {
  email: undefined,
  initials: undefined,
  name: undefined
};

export const GET_MEMBER_NOTES_PER_PAGE_COUNT = 50;

export const CREATE_MEMBER_NOTE_FAILURE = 'Failed to create note';
